let items = document.querySelector('.header__inline-menu').querySelectorAll('details');
let menus = document.querySelectorAll('.mega-menu__content');
const border = document.getElementById('ap-nav-tab');
let single_menus = document.querySelectorAll('.header__menu-item');

single_menus.forEach((menu) => {
  menu.addEventListener('mouseover', () => {

    items.forEach((el) => el.removeAttribute('open'));
  });
});

items.forEach((item) => {
  item.addEventListener('mouseover', () => {
    document
      .querySelector('.header__inline-menu')
      .querySelectorAll('details')
      .forEach((el) => el.removeAttribute('open'));
    item.setAttribute('open', true);
    const megaMenu = document.querySelector('ul.list-menu--inline');
    const menuItems = document.querySelectorAll('ul.list-menu--inline details');
    let activeMenuItem = item;
    const border = document.getElementById('ap-nav-tab');

    if (activeMenuItem) {
      const activeMenu = activeMenuItem.querySelector('summary');
      const activeMenuRect = activeMenu.getBoundingClientRect();

      const megaMenuRect = megaMenu.getBoundingClientRect();
      const activeMenuItemRect = activeMenuItem.getBoundingClientRect();
      const offsetLeft = activeMenuItemRect.left - megaMenuRect.left;
      const paddingLeft = parseFloat(window.getComputedStyle(activeMenuItem).paddingLeft) || 0;
      const offsetPercentage = (offsetLeft / megaMenuRect.width) * 100 + (paddingLeft / megaMenuRect.width) * 100;
      border.style.left = offsetPercentage + '%';

      border.style.width = activeMenuRect.width + 'px';
    }
  });
});

menus.forEach((menu) => {
  menu.addEventListener('mouseleave', () => {
    items.forEach((el) => el.removeAttribute('open'));
    border.style.width = '0px';
  });
});

document.querySelectorAll('.weezie-mobile__header-top-menu').forEach((parentDetails) => {
  parentDetails.addEventListener('click', function (event) {
    event.stopPropagation();
    document.querySelectorAll('.weezie-mobile__header-top-menu').forEach((otherDetails) => {
      if (otherDetails !== this) {
        otherDetails.removeAttribute('open');
      }
    });
  });
});

document.querySelectorAll('.weezie-menu-drawer__menu').forEach((childDetails) => {
  childDetails.addEventListener('click', function (event) {
    event.stopPropagation();
    this.closest('.weezie-mobile__header-top-menu')
      .querySelectorAll('.weezie-menu-drawer__menu')
      .forEach((otherChild) => {
        if (otherChild !== this) {
          otherChild.removeAttribute('open');
        }
      });
  });
});

// Code for header logo scroll up change
const logoWrapper = document.querySelector('.header__heading-logo-wrapper');

if (logoWrapper) {
  let lastScrollY = window.scrollY;

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;

    if (currentScrollY > lastScrollY) {
      logoWrapper.classList.add('scrolled');
    } else if (currentScrollY < lastScrollY) {
      logoWrapper.classList.remove('scrolled');
    }

    lastScrollY = currentScrollY;
  });
}

